import axios from "axios";

export const API_BASE_URL =
    process.env.VUE_APP_API_BASE_URL ||
    (process.env.NODE_ENV === "development"
        ? "http://localhost:3010"
        : "http://194.180.11.123:3010");

export const AxiosUtil = axios.create({
    baseURL: API_BASE_URL
});
